import {schema as Schema} from 'normalizr';

export const programsListEntity = new Schema.Entity('byId', {}, {idAttribute: 'id'});
export const programsListSchema = new Schema.Array(programsListEntity);
